import axios from 'axios';
import { BASE_URL } from "../../config/api";
import moment from 'moment';
import { header } from '../../Redux/Actions/actions';
import AuthService from '../../components/services/auth-service';

const checkEmptyDate = (loanNumber:number, pageSize, startDate:string, endDate:string, pageValues:string, loanTypes:string, searchValues:string) => {
  if(startDate === '' && endDate === '') return `${BASE_URL}/admin/loan/loan-status?status=${loanNumber}&PageNumber=${pageValues}&PageSize=${pageSize}&loanType=${loanTypes}&searchString=${searchValues}`
  else if (endDate === '') return `${BASE_URL}/admin/loan/loan-status?status=${loanNumber}&PageNumber=${pageValues}&PageSize=${pageSize}&loanType=${loanTypes}&searchString=${searchValues}&startDate=${startDate}&endDate=${moment(startDate).add(1, 'd').format('YYYY-MM-DD')}`
  return `${BASE_URL}/admin/loan/loan-status?status=${loanNumber}&PageNumber=${pageValues}&PageSize=${pageSize}&loanType=${loanTypes}&searchString=${searchValues}&startDate=${startDate}&endDate=${endDate}`
}

export const getFilteredLoans = (loanNumber, pageSize, pageValues, searchValues, loanTypes, 
  setCurrentItems, setLoading, endDate, startDate) => {
    setLoading(true)
    return axios
    .get(checkEmptyDate(loanNumber, pageSize, startDate, endDate, pageValues, loanTypes, searchValues), {
      headers: {
        'content-type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      }
    }).then((res) =>{ setLoading(false);
      if(res?.data?.data?.length === 0)setCurrentItems([])
      setCurrentItems(res?.data?.data);
      // if(loanNumber === 8)setCurrentItems(res?.data?.data?.filter(loan => loan?.vendorDetailStatus ==='Invalid Vendor Details')); 
    })
    .catch((error) => {
      setLoading(false)
      if(error?.response?.status === 401){
        localStorage.clear()
        // window.location.href = '/'
      }
      // dispatch({ type: types.LOGIN_FAILURE, message: error.message });
      throw error;
    });   
}

export const pageValueState = (pageValues, setPageValues) => {
   if(pageValues === '') setPageValues(1)
}

export const pageSize = 100;

export var month = new Date().toLocaleString("de-DE", { month: "long" });

export const monthChecker = () => {
  if(month === 'Dezember'){
    month = 'December'
  }else if(month === 'Januar'){
    month = 'January'
  }else if(month === 'Februar'){
    month = 'February'
  }else if(month === 'März'){
    month = 'March'
  }else if(month === 'April'){
    month = 'April'
  }else if(month === 'Mai'){
    month = 'May'
  }else if(month === 'Juni'){
    month = 'June'
  }else if(month === 'Juli'){
    month = 'July'
  }else if(month === 'August'){
    month = 'August'
  }else if(month === 'September'){
    month = 'September'
  }else if(month === 'Oktober'){
    month = 'October'
  }else if(month === 'November'){
    month = 'November'
  }
  return month
};

export const logoutUser = async (username) => {
  try {
    if (username) {
      const response: any = await AuthService.logoutUser(username);

      if (response?.status) {
        localStorage.clear();
        window.location.href = "/";
      } else {
        console.error('Logout failed:', response);
      }
    } else {
      throw new Error('Username is required');
    }
  } catch (error) {
    console.error('Error during logout:', error);
  }
};
